module.exports = __webpack_public_path__ + "static/img/26830.f03872b.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/ztcl/26830.png
// module id = Zim1
// module chunks = 0